import { render } from "./BaseSubMenu.vue?vue&type=template&id=1a71dc84&scoped=true"
import script from "./BaseSubMenu.vue?vue&type=script&lang=js"
export * from "./BaseSubMenu.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1a71dc84"

export default script